import { Base } from "./base";

export default class ShareService extends Base {
	constructor () {
		super()
	}

	async index( id ) {
		return this.sharePage_index( id )
	}

	async Data( id ) {
		const res = await this.index( id )
		const { posts: { column, data, share } } = res

		const index = {
			type: 'index',
			plate_info: {
				...data,
				// title: data.name,
				// name: data.name1,
				title_logo: data.logo,
				desc: data.content && JSON.parse( data.content ).map( item => ( { label: item.name, value: item.info } ) ),
				background: data.background
			}
		}

		const newColumn = column.map( ( item, index ) => {
			if ( index == 0 ) {
				item[ 'active' ] = true
			}
			if ( item.list ) {
				item.list = item.list.map( listItem => {
					if ( listItem.type == 5 ) {
						listItem = {
							...listItem,
							guest_item_box_expand: false
						}
					} else if ( listItem.type == 22 ) {
						listItem = {
							...listItem
						}
					} else if ( listItem.type == 23 ) {
						if ( listItem.is_public == 1 ) {
							listItem = {
								...listItem,
								agenda_item_box_expand: false
							}
						} else if ( listItem.is_public == 2 ) {
							let newDates = []

							JSON.parse( listItem.desc ).map( ( j, k ) => {
								if ( j.type == 1 ) {
									newDates.push( {
										date: j.times,
										timeline: []
									} )
								} else if ( j.type == 2 ) {
									newDates[ newDates.length - 1 ].timeline.push( {
										label: j.times,
										info: j.info
									} )
								}
							} )

							listItem = {
								...listItem,
								timeline_expand: false,
								dates: newDates
							}
						}
					}

					return listItem
				} )
			}

			return item
		} )

		const page_data = [ index ].concat( newColumn )


		return {
			page_data,
			share
		}
	}
}
